import type { BillingProduct } from "@/react/api/billingCyclesApi";
import { absolutePath } from "./absolutePath";

export const AccountSubscriptions = {
  getBillingCycles: (limit?: number, products?: BillingProduct[]) =>
    absolutePath("/account_subscriptions/billing_cycles", {
      ...(limit && { limit }),
      ...(products && { products }),
    }),
  update: (
    planId: number,
    planCouponId: number,
    source: Record<string, unknown>,
  ) => {
    const payload = {
      plan_id: planId,
      plan_coupon_id: planCouponId,
      ...(source && { source }),
    };
    return absolutePath("account_subscriptions", payload);
  },
  renew: (planId: number) =>
    absolutePath("account_subscriptions/renew", { plan_id: planId }),
  canDowngrade: (planId: number) =>
    absolutePath("account_subscriptions/can_downgrade", { plan_id: planId }),
  createEmailHubSubscription: () =>
    absolutePath("account_subscriptions/create_email_hub_subscription"),
  reactivateEmailHubSubscription: () =>
    absolutePath("account_subscriptions/reactivate_email_hub_subscription"),
};
